import React from 'react';
import PropTypes from 'prop-types';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @typedef {PropTypes.InferProps<typeof propTypes>} Props
 */
const IconArrowLeft = ({ className }) => {
    return (
        <svg
            className={className ? className : ''}
            fill='none'
            height={'15px'}
            viewBox='0 0 8 15'
            width={'9px'}
            xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M7.5 14L1 7.5L7.5 1'
                stroke='white'/>
        </svg>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

const propTypes = {
    className: PropTypes.string,
};

IconArrowLeft.propTypes = propTypes;

export default IconArrowLeft;
